import { render, staticRenderFns } from "./PreferencesCalendar.vue?vue&type=template&id=52ed096c"
import script from "./PreferencesCalendar.vue?vue&type=script&lang=js"
export * from "./PreferencesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports